import styled from 'styled-components';
export const StyledChargeList = styled.div`
  margin-bottom: 1.2rem;

  @media screen and (min-width: 768px) {
    margin-bottom: 1.8rem;
  }
`;
